import React, { FC, useEffect } from 'react'
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'

import { Typography, CustomLinearProgress } from '@dg-shared'
import { useTranslate } from '../../../hooks/shared'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: () => ({
      alignItems: 'center',
      minHeight: '100vh',
      alignContent: 'start',
      padding: theme.spacing(2),
      [theme.breakpoints.down('md')]: theme.brand.assets.pageBackgrounds.loadingMobile,
      [theme.breakpoints.up('md')]: theme.brand.assets.pageBackgrounds.loading,
      [theme.breakpoints.up('lg')]: {
        padding: 0,
      },
    }),
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.up('md')]: {
        alignItems: 'center',
        maxWidth: '425px',
      },
    },
    logoMobileHeader: {
      [theme.breakpoints.down('sm')]: {
        ...theme.brand.assets.images.logoMobileHeader,
      },
    },
    title: {
      marginBottom: theme.spacing(3),
      ...theme.brand.assets.layout?.loadingTitle,
      [theme.breakpoints.down('md')]: {
        marginTop: theme.spacing(25),
        ...theme.brand.assets.layout?.loadingTitleMobile,
      },
      [theme.breakpoints.up('md')]: {
        marginBottom: theme.spacing(4),
        ...theme.brand.assets.layout?.loadingTitle,
      },
    },
    progress: {
      width: '100%',
      padding: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        padding: 0,
      },
    },
  })
)

const LoadingPage: FC = () => {
  const { t } = useTranslate()
  const classes = useStyles()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Grid container justifyContent='center' className={classes.container}>
      <Grid item xs={12} className={classes.wrapper}>
        <div data-testid='loading' className={classes.logoMobileHeader} />
        <Typography testId='loading-title' type='h1' className={classes.title}>
          {t('loading.title')}
        </Typography>
        <div className={classes.progress}>
          <CustomLinearProgress id='loading-linear-progressbar' />
        </div>
      </Grid>
    </Grid>
  )
}

export default LoadingPage
